import { parseISO, format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export const formatDateWithTime = (dateString) => {
    if (!dateString) 
      {
        console.log('dateString is null, undefined, or empty string ' + dateString);
        return 'N/A';
      }
    
    // Attempt to parse the string into a Date object assuming an ISO format
    const date = parseISO(dateString);

    // Check if date is valid
    if (isNaN(date)) 
      {
        return 'N/A';
      }

    // Format date into a readable string, adjust format string as needed
    return format(date, 'M/d/yyyy h:mm a'); // using date-fns format
};


export const formatDate = (dateString) => {
  if (!dateString) return 'N/A';

  try {
      // If it’s already just a calendar date, tack on Z so it parses as UTC midnight
      const iso = /^\d{4}-\d{2}-\d{2}$/.test(dateString)
          ? `${dateString}T00:00:00Z`
          : dateString;

      const date = parseISO(iso);
      if (Number.isNaN(date)) return 'N/A';

      // Always format in UTC so 00:00 never shifts to the prior evening locally
      return formatInTimeZone(date, 'UTC', 'M/d/yyyy');
  } catch {
      return 'N/A';
  }
};

export const properCase = (str) => {
    if (!str) 
      {
        return 'N/A';
      }
    return str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
}

export const handlePdfFile = (pdfBlob, fileName, action) => {
  const url = window.URL.createObjectURL(
    new File([pdfBlob], fileName, { type: 'application/pdf' })
  );

  try {
    switch(action) {
      case 'download': {
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName;
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        break;
      }
      case 'open': {
        // Create a temporary link to preserve filename in browser history
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.click();
        break;
      }
      case 'print': {
        const printWindow = window.open(url, '_blank');
        if (printWindow) {
          printWindow.document.title = fileName;
          printWindow.addEventListener('load', () => {
            printWindow.print();
            // Add filename to print dialog through document title
            printWindow.document.title = fileName;
          }, { once: true });
        }
        break;
      }
      default:
        console.warn('Unknown PDF action:', action);
    }
  } finally {
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
    }, 30000); // Longer timeout for print/open scenarios
  }
};

export const extractErrorMessage = async (error) => {
  if (!error) return 'Unknown error';

  try {
    if (error.response) {
      const data = error.response.data;
      if (data) {
        if (data instanceof Blob) {
          const text = await data.text();
          try {
            const json = JSON.parse(text);
            return json.message || json.detail || json.error || text;
          } catch {
            return text;
          }
        }

        if (typeof data === 'object') {
          return data.message || data.detail || JSON.stringify(data);
        }

        if (typeof data === 'string') {
          try {
            const json = JSON.parse(data);
            return json.message || json.detail || data;
          } catch {
            return data;
          }
        }
      }
      return error.response.statusText || error.message;
    }
    return error.message;
  } catch {
    return error.message;
  }
};